import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M7.018 10.176V4.438c0-.877.712-1.589 1.59-1.589h8.628L21 6.613v12.864c0 .877-.711 1.589-1.589 1.589h-7.385"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.338 14.127c1.178-.396 3.445-.633 1.22-1.813-.987-.522-2.014-.372-2.903.01-1.807.764-2.817 2.46-2.886 4.404-.059 2.05 1.518 3.672 3.037 4.195 1.385.486 3.093.361 4.254-.515 1.651-1.223 2.015-2.506 1.864-3.564"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M5.237 17.066c.392.47 1.203 1.385 1.31 1.277.108-.107 1.77-1.86 2.589-2.722"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M18.244 13.403h-6.487M9.707 9.84h8.369M18.311 16.63h-4.94M17.034 3.05v2.732a1 1 0 0 0 1 1h2.495"
    />
  </svg>
);
export const GuidesIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
